
@if(taskInfos && task){
    <div class="container-fluid container-fluid-limited">
        <div class="mt-4 mx-md-4 taskbook">
            <div class="pt-3">
                <div class="d-lg-flex justify-content-between px-3">
                    <div class="pb-3 pb-lg-0 d-flex align-items-center justify-content-between justify-content-lg-start gx-3">
                        <button routerLink="/backlog"  class="btn btn-back task-detail-btn">
                            <i class="fa-solid fa-arrow-left"></i> {{ 'backlog.task_details.back' | translate }}
                        </button>
                        <button (click)="onAction({task: task, action:archiveTaskAction})" class="btn btn-archive task-detail-btn px-4 ms-lg-2">
                                <i class="fa-light me-2" [ngClass]="archiveTaskAction.icon"></i> {{ archiveTaskAction.label.title | translate }}
                        </button>
                    </div>
                    <div class="d-flex align-items-center">
                        <multi-task-label-popover-selector [selectedLabels]="labelSelection"
                                                            [selectedItems]="[task]"
                                                            [context]="'taskDetails'"
                                                            (labelsChange)="onApplyLabelSelection($event)"></multi-task-label-popover-selector>
                    
                        <task-detail-actions [task]="task"
                                            (onAction)="onAction($event)"></task-detail-actions>
                    </div>
                </div>
                <hr class="mt-3 pt-0 mb-0">
            </div>
            <div class="row mx-0">
                <div class="col-md-6 task-preview task-detail-col">
                    <div class="">
                        <task-labels [labels]="task.labels"
                                    (onLabelChange)="onApplyLabelSelection($event)"></task-labels>
                    </div>
                    <div class="pt-3">
                        <task [task]="task"
                                [teams]="teams"
                                [userId]="userId"
                                [userInfos]="userInfos"
                                [threadInCreation]="threadInCreation"
                                (onAction)="onThreadCreation($event)"></task>
                    </div>
                </div>
                <div class="col-md-6 task-activity task-detail-col">
                    <div class="pb-4 border-bottom mb-2">
                        <div class="pb-3">
                            <p class="fs-5 text-secondary manager-comments">{{ 'backlog.task_details.assignees' | translate }}</p>
                            <small class="d-block">{{'backlog.task_details.assignees_desc' | translate}}</small>
                        </div>
                        <div class="">
                            
                            <div class="assignee-chips">
                                <multi-task-assignee-selector [selectedAssignees]="task?.assignees"
                                                                [managers]="taskInfos.managers"
                                                                [selectedItems]="[task]"
                                                                [context]="'taskDetails'"
                                                                (assigneesChange)="onAssigneeSelectionChanged($event)"></multi-task-assignee-selector>
                                @for (assignee of task?.assignees; track assignee.id){
                                    <mat-chip-row class="blue-chip-row  py-1" (removed)="removeAssignee(assignee)">
                                        {{assignee.firstname}} {{assignee.lastname}}
                                        <button matChipRemove [attr.aria-label]="'remove ' + assignee.firstname + ' ' + assignee.lastname">
                                            <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }
                            </div>
                        </div>
                       
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="fs-5 text-secondary manager-comments">{{ 'backlog.task_details.manager_comments' | translate }}</p>
                    </div>
                    <div><small>{{'backlog.task_details.manager_comments_subtitle' | translate}}</small></div>
                    <div class="threads border-0 pb-2">
                        <manager-comment-input [comment]="newComment"
                                                [commentAuthors]="managerListForMentions"
                                                (onCommentAdded)="onCommentAdded($event)"
                                                [setFocus]="null" #newCommentComponent></manager-comment-input>
                    </div>
                    <p class="review-history">
                        @for(review of filteredReviews; track $index){
                            <review-history-element [review]="review"
                                                    [userId]="userId"
                                                    [teams]="teams"
                                                    [commentAuthors]="commentAuthors"
                                                    (editReviewComment)="editReviewComment($event)"
                                                    (deleteReviewComment)="deleteReviewComment($event)"></review-history-element>
                        }
                    </p>
                </div>
            </div>
        </div>
    </div>

}
